"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dblogsOpenApiDocs = void 0;
const accessDeniedResponse = {
    description: 'Access denied — super admin required',
    returnParams: {
        type: 'object',
        properties: {
            success: { type: 'boolean', example: false },
            error: { type: 'string' },
            code: { type: 'number', example: 10001 }
        }
    }
};
const badRequestResponse = {
    description: 'Invalid filter parameters',
    returnParams: {
        type: 'object',
        properties: {
            success: { type: 'boolean', example: false },
            error: { type: 'string', description: 'Semicolon-separated list of validation errors', example: 'dateFrom must be in YYYY-MM-DD format; page must be an integer >= 1' },
            code: { type: 'number', example: 10003 }
        }
    }
};
exports.dblogsOpenApiDocs = {
    'dblogs.filters': {
        description: 'Returns the list of loggable model names and available operation types for use in the DB logs search filters.',
        responses: {
            200: {
                description: 'Filter options retrieved successfully',
                returnParams: {
                    type: 'object',
                    properties: {
                        success: { type: 'boolean', example: true },
                        models: {
                            type: 'array',
                            description: 'List of all loggable model collection names',
                            items: { type: 'string' },
                            example: ['user', 'avatar', 'conversation']
                        },
                        operations: {
                            type: 'array',
                            description: 'List of all tracked DB operation types',
                            items: {
                                type: 'string',
                                enum: ['create', 'update', 'delete', 'upsert', 'createMany', 'updateMany', 'deleteMany']
                            }
                        }
                    }
                }
            },
            403: accessDeniedResponse
        }
    },
    'dblogs.search': {
        description: 'Returns paginated DB operation logs with optional filters for model, operation type, and date range. Super admin only.',
        payload: {
            body: {
                type: 'object',
                properties: {
                    dateFrom: {
                        type: 'string',
                        format: 'date',
                        description: 'Start date filter (inclusive)',
                        example: '2026-05-01'
                    },
                    dateTo: {
                        type: 'string',
                        format: 'date',
                        description: 'End date filter (inclusive, extended to end of day)',
                        example: '2026-05-08'
                    },
                    models: {
                        type: 'array',
                        description: 'Filter by model collection names  (empty searches for all records)',
                        items: { type: 'string' },
                        example: ['user', 'avatar']
                    },
                    operations: {
                        type: 'array',
                        description: 'Filter by operation types (empty searches for all records)',
                        items: {
                            type: 'string',
                            enum: ['create', 'update', 'delete', 'upsert', 'createMany', 'updateMany', 'deleteMany']
                        }
                    },
                    recordIds: {
                        type: 'array',
                        description: 'Filter by specific record IDs (empty searches all records)',
                        items: { type: 'string' }
                    },
                    page: {
                        type: 'integer',
                        description: '1-based page number',
                        default: 1
                    },
                    perPage: {
                        type: 'integer',
                        description: 'Number of results per page',
                        default: 50
                    },
                    language: {
                        type: 'string',
                        description: `Language code for translated labels. Supported: en, pl, de, es, it, zh`,
                        example: 'en'
                    }
                }
            }
        },
        responses: {
            200: {
                description: 'Logs retrieved successfully',
                returnParams: {
                    type: 'object',
                    properties: {
                        success: { type: 'boolean', example: true },
                        data: {
                            type: 'array',
                            items: {
                                type: 'object',
                                properties: {
                                    id: { type: 'string' },
                                    modelName: { type: 'string', description: 'Collection name of the affected model' },
                                    modelLabel: { type: 'string', description: 'Translated model label' },
                                    operation: {
                                        type: 'string',
                                        enum: ['create', 'update', 'delete', 'upsert', 'createMany', 'updateMany', 'deleteMany']
                                    },
                                    operationLabel: { type: 'string', description: 'Translated operation label' },
                                    recordId: { type: 'string', nullable: true },
                                    payload: { type: 'object', nullable: true, description: 'Input data of the operation', additionalProperties: true },
                                    result: { type: 'object', nullable: true, description: 'Output data of the operation', additionalProperties: true },
                                    created_at: { type: 'string', format: 'date-time' }
                                }
                            }
                        },
                        count: { type: 'integer', description: 'Total number of matching logs' },
                        page: { type: 'integer', description: 'Current 1-based page' },
                        totalPages: { type: 'integer' }
                    }
                }
            },
            403: accessDeniedResponse,
            400: badRequestResponse
        }
    }
};
